import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';

export const useApplyPattern = (projectUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation<{ updated: number }, Error, string>({
    mutationFn: (uuid) => apiClient.post(`/v1/projects/${projectUuid}/patterns/${uuid}/apply`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectUuid] });
    },
  });
};
